export default __webpack_public_path__ + "static/media/exampleEN.db43d64b.jpg";